<template>
    <the-input
        v-bind="$attrs"
        v-on="$listeners"
        :validation="validation"
        @input="localText = $event"
    />
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },

    methods: {
        validation(str = '') {
            // First we need to determine the type of product,
            // because for weight products we need to allow 7 digits, and for others 13 digits
            let productType = null
            if (this.product && this.product.available_in_promos !== undefined) {
                productType = this.product.available_in_promos
            } else if (
                this.product &&
                this.product.dict_product &&
                this.product.dict_product.available_in_promos !== undefined
            ) {
                productType = this.product.dict_product.available_in_promos
            }
            const substringLength = productType === 'weight' && str.startsWith('2') ? 7 : 13

            return str
                .replace(/[^0-9]/g, '')
                .substring(0, substringLength)
        }
    }
}
</script>